export default {"src":"/_next/static/media/Cutsomisable.cb34c958.svg","height":80,"width":80,"blurWidth":0,"blurHeight":0};